/**
 * 訃告模式總開關
 *
 * 還原方法：
 *   1) 把 MOURNING_MODE 改為 false → 全站停止灰階、訃告 popup 與「訃告」按鈕全部消失
 *   2) 如需徹底移除，刪除此檔案，並移除 App.tsx / TopBanner.tsx 中的相關 import 與 JSX
 */
export const MOURNING_MODE = true;

/** 套用於 App 最外層容器的 class（樣式定義在 src/index.css） */
export const MOURNING_CLASS = "pkps-mourning";

/** 關閉後記錄用的 sessionStorage key：同一瀏覽 session 內只自動彈出一次 */
export const MOURNING_STORAGE_KEY = "pkps-mourning-notice-closed";
